import { ca } from '@cian/analytics';

import { TTrackingParamsType } from '../../../types/page/trackingParamsType';

export const trackTabClick = ({ dealType, siteType, cianSource }: TTrackingParamsType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'RentContract',
    action: 'Click_tab_sopr',
    label: dealType,
    page: {
      pageType: 'OnlineRentContract',
      siteType,
      extra: {
        dealType,
        cian_source: cianSource,
      },
    },
  });
};
